module.exports = new __parcel__URL__("shelf-background.0e6f710f.png").toString();